export default "__VITE_ASSET__cc7b2d38__"